export var SHOWROOM_APPAREL_C2_TITLE_BANNER_DISMISSED = 'SHOWROOM_APPAREL_C2_TITLE_BANNER_DISMISSED';
